<template>
  <div class="focusDetail-page margin-l-20">
    <div class="Focus-detail-header margin-r-40 margin-l-20">
      <el-date-picker class="margin-l-20" v-model="times" type="month" placeholder="选择月" :clearable="false"
                      format="yyyy-MM" value-format="yyyy-MM" @change="getCompanyAll" :picker-options="pickerOptions"></el-date-picker>
    </div>

      <el-row>
        <el-col :span="14">
          <p class="index-header-title margin-l-20">企业网络零售画像</p>
          <el-card class="margin-l-20 " style="height: 540px;">
            <el-col :span="12">
          <chart ref="chart4" :options="HDIOptions" autoresize class="width-z100 padding-r-20"></chart>
            </el-col>
          <!--          <div style="float: right;margin-top: -45px">企业综合评分:{{exponent.comindexShow}}分</div>-->
            <el-col :span="12">
          <h1 class="margin-t-40 margin-l-30 margin-b-40" style="color: #333333">{{companyInfo.companyname}}
            <el-tag class="margin-l-5">企业指数：{{exponent.comindexShow }}分</el-tag>
          </h1>
          <div class="margin-b-15 margin-l-30" style="color: #666666">社会统一信用代码：{{companyInfo.keyno}}</div>
          <div class="margin-b-15 margin-l-30" style="color: #666666">工商注册号：{{companyInfo.regno}}</div>
          <div class="margin-b-15 margin-l-30" style="color: #666666">成立日期：{{companyInfo.startdate}}</div>
          <div class="margin-b-15 margin-l-30" style="color: #666666">法定代表人：{{companyInfo.opername}}</div>
          <div class="margin-b-15 margin-l-30" style="color: #666666">注册资本：{{companyInfo.registcapi}}</div>
          <div class="margin-b-15 margin-l-30" style="color: #666666">登记机关：{{companyInfo.registOrgization}}</div>
          <div class="margin-b-15 margin-l-30" style="color: #666666">注册地址：{{companyInfo.address}}</div>
          <div class="margin-b-15 margin-l-30" style="color: #666666">住所：{{companyInfo.location}}</div>
          <!--          <div class="margin-b-20">在南昌市排名第18名<span class="margin-l-30">在科技公司排名第18名</span></div>-->
            </el-col>
          </el-card>
        </el-col>
        <el-col :span="10" class="padding-l-30 text-left padding-r-40">
          <p class="index-header-title">企业旗下店铺</p>
          <el-card>
            <el-table :data="shopTop" class="colorChang border-DEDEDE" height="500"
                      :default-sort="{prop: 'money', order: 'descending'}">
              <el-table-column type="index" label="排名" width="70" align="center"></el-table-column>
              <el-table-column prop="storename" label="店铺名称" align="center"
                               :show-overflow-tooltip="true"></el-table-column>
              <el-table-column prop="platname" label="平台" width="120" align="center"></el-table-column>
              <el-table-column prop="salesofmonth" label="当期网络零售额（万元）" align="center"></el-table-column>
              <el-table-column prop="salesofyear" label="累计网络零售额（万元）" align="center"></el-table-column>
            </el-table>
          </el-card>

        </el-col>
      </el-row>
    <div class="margin-t-30 margin-r-40 margin-l-20">
<!--      <p class="index-header-title">企业当期网络零售额变化趋势</p>-->
      <el-card>
        <chart ref="chart4" :options="moneyOptions" autoresize class="width-z100 margin-t-10"
               style="margin-top: 20%"></chart>
      </el-card>
    </div>

    <div class="margin-t-10 margin-b-20 margin-r-20 margin-l-20">
      <el-row>
        <el-col :span="8" class="padding-r-20">
          <p class="index-header-title">品牌榜</p>
          <el-card>
            <el-table :data="brandList" height="500" class="border-DEDEDE"
                      :default-sort="{prop: 'money', order: 'descending'}">
              <el-table-column type="index" label="排名" width="100" align="center"></el-table-column>
              <el-table-column prop="name" label="品牌" align="center"></el-table-column>
<!--              <el-table-column prop="absolute_value" label="销售额（元）" width="150" align="center"></el-table-column>-->
            </el-table>
          </el-card>
        </el-col>
        <el-col :span="16" class="padding-r-20">
          <p class="index-header-title">企业热销单品榜</p>
          <el-card>
            <el-table :data="goodsTopList" width="480px" height="500" class="border-DEDEDE"
                      :default-sort="{prop: 'absolute_value', order: 'descending'}">
              <el-table-column type="index" label="排名" width="100" align="center"></el-table-column>
              <el-table-column prop="name" label="商品名称" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <a :href="scope.row.url"
                     target="_blank"
                     class="buttonText text-7ce2ff" style="text-decoration: none">{{scope.row.name}}</a>
                </template>
              </el-table-column>
              <el-table-column prop="absolute_value" label="销售额（元）" align="center"></el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
    export default {
        name: "focusDetail",
      data () {
        return {
          times: '',
          HDIOptions: {}, //企业发展指数雷达图
          id: this.$route.query.id, //获取企业id
          keyNo: '', //获取企业keyNo
          companyInfo: {},//企业信息
          brandList: [],//品牌榜
          moneyOptions: {},//企业近12个月销售额同比图
          goodsTopList: [],//企业热销单品排行榜
          shopOptions: {},//企业名下店铺图表
          shopPieOptions: {},//各店铺占比
          shopTop: [],//企业名下店铺列表
          exponent: {},//指数相关数据
          // monthsalsTop: [],//企业历史月份销售情况
          pictLoading: true,
          wholeForm: {type: '1', sMonth: '', eMonth: ''},//整体情况筛选条件

          // numberList:{city:[]}
          items: [
            {type: 'danger', label: 'Top1'},
            {type: 'success', label: 'Top2'},
            {type: 'brand ', label: 'Top3'},
            {type: 'info', label: 'Top4'},
            {type: 'info', label: 'Top5'},
            {type: 'info', label: 'Top6'},
            {type: 'info', label: 'Top7'},
            {type: 'info', label: 'Top8'},
            {type: 'info', label: 'Top9'},
            {type: 'info', label: 'Top10'}
          ],
          pickerOptions: {
            disabledDate: (time) => {
              // console.log(time.getMonth());
              let nowDate = new Date()
              let day = nowDate.getDate()
              nowDate.setDate(1)
              if (day > 14) {
                if (nowDate.getMonth() == 0) {
                  nowDate.setMonth(11)
                  nowDate.setFullYear(nowDate.getFullYear() - 1)
                } else {
                  nowDate.setMonth(nowDate.getMonth() - 1)
                }
              } else {
                if (nowDate.getMonth() == 0) {
                  nowDate.setMonth(10)
                  nowDate.setFullYear(nowDate.getFullYear() - 1)
                } else if (nowDate.getMonth() == 1) {
                  nowDate.setMonth(11)
                  nowDate.setFullYear(nowDate.getFullYear() - 1)
                } else {
                  nowDate.setMonth(nowDate.getMonth() - 2)
                }
              }
              if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
            }
          },
        }
      },
      mounted () {

      },
      created () {
        this.$emit('public_header', true)
        this.oneMonth()
        // this.getCompanyDetail()
        this.getCompanyIndex()
        // this.getCompanyMoney()
        this.getCompanyTop()
        // this.getCompanySales()
        // this.getGoodsRank()
      },
      methods: {
        getCompanyAll () {
          // this.getCompanyTop()
          // this.getCompanyDetail()
          this.getCompanyIndex()
          // this.getCompanyMoney()
          this.getCompanyTop()
          // this.getCompanySales()
          // this.getGoodsRank()
        },

        // //获取企业详细信息
        // getCompanyDetail () {
        //   if (this.wholeForm.type == '1') {
        //     this.wholeTitle = '当期网络零售额'
        //   } else {
        //     this.wholeTitle = '累计网络零售额'
        //   }
        //   this.$http.get(this.header + '/importantCompany/info', {
        //     params: {
        //       times: this.times,
        //       id: this.id
        //     }
        //   }).then(res => {
        //     if (res.data.code == 0) {
        //       this.companyInfo = res.data.info
        //
        //     } else {
        //       this.$alert(res.data.msg)
        //     }
        //
        //   })
        // },

        //获取企业详细雷达图
        getCompanyIndex () {
          console.log( this.keyNo)
          this.$http.get(this.header + '/importantCompany/importantInfo', {
            params: {
              id: this.id,
              times: this.times,
            }
          }).then(res => {
            if (res.data.code == 0) {
              this.exponent = res.data.comindex
              this.companyInfo = res.data.info
              let avgComindex= res.data.avgComindex
              if (this.exponent.comIndexShow == null) {
                this.exponent.comIndexShow = '--'
              }
              //企业近12个月销售额同比图
              let companyMoneyList = {xTime: [], yTotalMoney: [], simple: []}
              res.data.monthSleslist.forEach((y, index) => {
                companyMoneyList.xTime.push(y.times)
                let yMoney = {
                  value: y.absoulte_value,
                  unit: '万元'
                }
                let xSimple = {
                  value: y.absoulte_value_yoy,
                  unit: '%'
                }
                companyMoneyList.yTotalMoney.push(yMoney)
                // this.wholeList.yTotalMoney.unit.push('万元')
                companyMoneyList.simple.push(xSimple)
                // this.wholeList.simpleUnit.push('%')
                // return label
              })
              let Min1 = this.calMin(companyMoneyList.yTotalMoney), Min2 = this.calMin(companyMoneyList.simple),
                Max1 = this.calMax(companyMoneyList.yTotalMoney), Max2 = this.calMax(companyMoneyList.simple)
              //企业近12个月销售额同比图
              this.moneyOptions = {
                color: ['#577EC5', '#F3B728'],
                title: {//图表标题
                  text: '企业当期网络零售额变化趋势',
                  left: 'left',
                  top: '5',
                  textStyle: {
                    color: '#313131',
                    fontSize: 18,
                    fontWeight: 300
                  },
                },
                tooltip: { // 鼠标悬浮
                  backgroundColor: 'rgba(50,50,50,0.7)',
                  trigger: 'item',
                  // trigger: 'axis',
                  // axisPointer: {
                  //   type: 'cross'
                  // },
                  formatter: function (e) {
                    // console.dir(e)
                    return e.name + e.seriesName + '<br/>' + e.value + e.data.unit
                    // '{b}{a}<br/>{c} 万元'
                  }
                  // formatter: '{a} <br/>{b}: {c} ',
                },
                toolbox: { //图表工具箱
                  feature: {
                    // dataView: {show: true, readOnly: false},
                    magicType: {show: true, type: ['line', 'bar']},
                    restore: {show: true},
                    saveAsImage: {show: true}
                  }
                },
                grid: {
                  left: '1%',
                  top: '15%',
                  right: '3%',
                  bottom: '10%',
                  containLabel: true
                },
                legend: {//图表说明  horizontal竖着显示vertical横显示
                  orient: 'horizontal',
                  y: 'bottom',
                  x: 'right',
                  textStyle: {
                    color: '#666666',
                    fontSize: 14
                  },
                  data: ['销售额', '同比']
                },
                xAxis: {
                  type: 'category',
                  data: companyMoneyList.xTime,
                  axisLine: {
                    lineStyle: {
                      color: '#666666'
                    }
                  }
                },
                yAxis: [
                  {
                    type: 'value',
                    name: '万元',
                    axisLine: {
                      lineStyle: {
                        color: '#666666'
                      }
                    },
                    min: Min1,
                    max: Max1,
                    splitNumber: 5,
                    interval: (Max1 - Min1) / 5
                  }, {
                    type: 'value',
                    name: '%',
                    // min: 0,
                    // max: 35,
                    // interval: 5,

                    axisLine: {
                      lineStyle: {
                        color: '#666666'
                      }
                    },
                    min: Min2,
                    max: Max2,
                    splitNumber: 5,
                    interval: (Max2 - Min2) / 5,
                    axisLabel: {
                      formatter: '{value} %'
                    }
                  }],
                series: [{
                  name: '销售额',
                  type: 'bar',
                  barCategoryGap: '60%',
                  barWidth: 30,
                  itemStyle: {
                    emphasis: {
                      color: '#83bff6'
                    }
                  },
                  data: companyMoneyList.yTotalMoney,
                  smooth: true
                }, {
                  name: '同比',
                  type: 'line',
                  yAxisIndex: 1,
                  data: companyMoneyList.simple
                }]
              }
              //企业雷达图
              this.HDIOptions = {
                color: ['#C4C5FE', '#76C4EC'],
                title: {
                  // text: '企业网络零售画像',
                  left: 'left',
                  textStyle: {
                    color: '#666666',
                    fontSize: 18
                  },
                },
                tooltip: {},
                legend: {
                  orient: 'horizontal',
                  y: 'bottom',
                  // x: 'left',
                  textStyle: {
                    color: '#666666',
                    fontSize: 14
                  },
                  data: [this.companyInfo.companyname, '重点企业平均']
                },
                radar: {
                  // shape: 'circle',
                  name: {
                    textStyle: {
                      color: '#666666',
                      // backgroundColor: '#999',
                      borderRadius: 3,
                      // padding: [30, 0]
                    }
                  },
                  indicator: [
                    // {name: '销量', max: 100},
                    {name: '销售额', max: 100},
                    {name: '增速', max: 100},
                    {name: '好评率', max: 100},
                    {name: '商品量', max: 100},

                  ],
                  splitArea: {
                    show: true,
                    areaStyle: {
                      color: ['#ffffff',]
                      // 图表背景网格的颜色
                    }
                  },
                  splitLine: {
                    show: true,
                    lineStyle: {
                      width: 1,
                      color: ['#EDEDED']
                      // 图表背景网格线的颜色
                    }
                  }
                },

                series: [{
                  name: '企业指数',
                  type: 'radar',
                  data: [

                    {
                      value: [ avgComindex.moneyShow, avgComindex.yoyShow, avgComindex.goodCommentShow, avgComindex.goodsNumShow],
                      name: '重点企业平均',
                      areaStyle: {
                        color: '#C4C5FE'
                      },
                      lineStyle: { // 单项线条样式。
                        normal: {
                          color: '#C4C5FE',
                          opacity: 0.5
                        }
                      },
                    },
                    {
                      value: [ this.exponent.moneyShow, this.exponent.yoyShow, this.exponent.goodCommentShow, this.exponent.goodsNumShow],
                      name: this.companyInfo.companyname,
                      areaStyle: {
                        color: '#66DDFF'
                      },
                      lineStyle: { // 单项线条样式。
                        normal: {
                          color: '#66DDFF',
                          opacity: 0.5
                        }
                      },
                    }
                  ],
                }]
              }
            } else {
              this.$alert(res.data.msg)
            }

          })
        },

        //获取企业top信息
        getCompanyTop () {
          if (this.wholeForm.type == '1') {
            this.wholeTitle = '当期网络零售额'
          } else {
            this.wholeTitle = '累计网络零售额'
          }
          this.$http.get(this.header + '/importantCompany/importRankInfo', {
            params: {
              times: this.times,
              id: this.id
            }
          }).then(res => {
            if (res.data.code == 0) {
              this.goodsTopList = res.data.goodsList
              this.shopTop = res.data.shopList
              this.brandList = res.data.brandList
              this.pictLoading = false
            } else {
              this.$alert(res.data.msg)
            }
          })
        },
        //获取企业排行榜信息
        // getGoodsRank () {
        //   if (this.wholeForm.type == '1') {
        //     this.wholeTitle = '当期网络零售额'
        //   } else {
        //     this.wholeTitle = '累计网络零售额'
        //   }
        //   this.$http.get(this.header + '/importantCompany/goodsRank', {
        //     params: {
        //       id: this.id,
        //       times: this.times,
        //     }
        //   }).then(res => {
        //     if (res.data.code == 0) {
        //       this.goodsTopList = res.data.goodsList
        //       this.brandList = res.data.brandList
        //     } else {
        //       this.$alert(res.data.msg)
        //     }
        //   })
        // },
        //计算最大值
        calMax (arr) {
          let max = 0
          // arr.forEach((el) => {
          arr.forEach((el1) => {
            if (!(el1 === undefined || el1 === '')) {
              if (max < el1.value) {
                max = el1.value
              }
            }
            // })
          })
          let maxint = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
          let maxval = maxint * 10//让显示的刻度是整数
          return maxval
        },

        //计算最小值
        calMin (arr) {
          let min = 0
          // arr.forEach((el) => {
          arr.forEach((el1) => {
            if (!(el1 === undefined || el1 === '')) {
              if (min > el1.value) {
                min = el1.value
              }
            }
          })
          // })
          let minint = Math.floor(min / 10)
          let minval = minint * 10//让显示的刻度是整数
          return minval
        },
        //选择近1个月
        oneMonth (val) {
          let dataArr = []
          let data = new Date()
          let day = data.getDate()
          data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
          for (let i = 0; i < 3; i++) {
            data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
            let m = data.getMonth() + 1
            m = m < 10 ? '0' + m : m
            dataArr.push(data.getFullYear() + '-' + (m))
          }
          if (day > 14) {
            this.times = dataArr[1]
          } else {
            this.times = dataArr[2]
          }

          // console.dir(dataArr)
        },
      }
    }
</script>

<style>


  .focusDetail-page .company-detail-header .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 120px;
  }

  .focusDetail-page .company-detail-header .el-date-editor input {
    /*background: #576A9F !important;*/
    width: 115px;
    height: 27px;
    line-height: 27px;
    border: 1px solid rgba(87, 106, 159, 4);
    /*color: RGBA(198, 212, 255, 1);*/
    margin-top: 23px!important;
  }
  .focusDetail-page .company-detail-bj{
    background: url("../../assets/company-bg.png");
    margin-right: 20px;
    margin-left: 30px;
    margin-top: 20px;
    height: 432px;
    border: 0px;
  }
  .focusDetail-page .company-detail-header .areaChoose input {
    background: rgba(36, 46, 71, 0.3) !important;
    border: 1px solid rgba(255, 255, 255, 0.3);
    /*width: 115px;*/
    height: 27px;
    line-height: 27px;
  }
  .focusDetail-page .company-Columns-title{
    color: #AAB8E4;
    margin-left: 30px;
    font-size: 18px;

  }
  .focusDetail-page .el-select .el-input__inner,.focusDetail-page .el-date-editor--month .el-input__inner {
    height: 30px;
    width: 130px;
    background-color: rgba(255, 255, 255, 1) !important;
    /*border-radius: 25px;*/
    color: #6B7991 !important;
  }
  .focusDetail-page .Focus-detail-header {
    text-align: left;
    margin-bottom: 8px;
    height: 54px;
    line-height: 54px;
    background: white;
    /*border: 1px solid rgba(100, 156, 238, 0.4);*/
    box-shadow: 0px 6px 7px 4px rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    color: #6589C5;
  }
  .focusDetail-page .index-header-title{
    /*font-weight: bold;*/
    margin-bottom: 10px;
    margin-top: 10px;
    color: #313131;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/focusDetail.vue